import React from 'react';
import _ from 'lodash';
import type { TOCHeader } from './ConnectedTableOfContents';
import styles from './TableOfContents.module.scss';

interface TableOfContentsProps {
  headers: TOCHeader[];
  activeH1?: string | null;
  activeH2?: string | null;
  activeH3?: string | null;
}

const TableOfContents = ({
  headers,
  activeH1 = null,
  activeH2 = null,
  activeH3 = null,
}: TableOfContentsProps) => (
  <ul className={styles.toc}>
    {headers.map(({ text, level, id }, i) => {
      if (_.isEmpty(text)) {
        return null;
      }

      let className = styles[`level${Math.min(level, 3)}`];
      if ([activeH1, activeH2, activeH3].includes(id)) {
        className += ` ${styles.active}`;
      }

      // We use the index as a react key because header text doesn't have to be unique
      const key = `${i}-${id}`;

      return (
        <li className={className} key={key}>
          <a href={`#${encodeURIComponent(id)}`} title={text}>
            {text}
          </a>
        </li>
      );
    })}
  </ul>
);

export default TableOfContents;
